export { ActivitiesComponent } from '@shared/layout/header/activities/activities.component';

export {ActivitiesMessageComponent} from '@shared/layout/header/activities/activities-message'
export {ActivitiesTaskComponent} from '@shared/layout/header/activities/activities-task'
export {ActivitiesNotificationComponent} from '@shared/layout/header/activities/activities-notification'



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/activities/index.ts